module.exports = __webpack_public_path__ + "static/img/case_detail_01_2.880dc7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_01_2.png
// module id = QsaI
// module chunks = 34